module.exports = "../fonts/hotel_food_icon.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hotel_food_icon.svg
// module id = 446
// module chunks = 0